<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="项目ID：" prop="project_id">
                <span>{{model.project_id}}</span>
            </el-form-item>
            <el-form-item label="项目名称：" prop="project_name">
                <span>{{model.project_name}}</span>
            </el-form-item>
            <el-form-item label="令牌：" prop="access_token">
                <span>{{model.access_token}}</span>
            </el-form-item>
            <el-form-item label="刷新令牌：" prop="refresh_token">
                <span>{{model.refresh_token}}</span>
            </el-form-item>
            <el-form-item label="过期时间：" prop="expire_time">
                <span>{{model.expire_time}}</span>
            </el-form-item>
            <el-form-item label="生成时间：" prop="create_time">
                <span>{{model.create_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'accessTokenInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                project_id: '',
                project_name: '',
                access_token: '',
                refresh_token: '',
                expire_time: '',
                create_time: '',
            },
            getObj:{
                url:'/api/admin/accesstoken/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>